/** 老公式改新公式 */

/** 对应的标题 */
const categoryMap = {
  SOFA: 'SOFA评分',
  GFR_Schwartz: 'GFR（Schwartz）',
  HAS_BLED: 'HAS-BLED评分',
  GRACE: 'GRACE评分',
  SanFrancisco: 'SanFrancisco晕厥规则',
  TIMI_NSTEMI: 'TIMI评分（NSTEMI）',
  TIMI_STEMI: 'TIMI评分（STEMI）',
  MAP: '平均动脉压',
  Padua: 'Padua预测评分',
  CEF: '心脏射血分数',
  Q_Tc: 'Q-Tc',
  GFR_Salazar: 'GFR（Salazar-Corcoran）',
  GFR_Cockcroft: 'GFR（Cockcroft-Gault）',
  CFWDPH: '高钠血症患者游离水缺乏量计算',
  UCE: '尿路钙排泄',
  FOF: '1秒率',
  GFR: 'GFR（肌酐已测定）',
  PESI: '简易化PESI',
  PREP: '肺栓塞PREP评分',
  BMI: '体重指数（BMI）',
  PERC: 'PERC',
  Geneva: 'Geneva肺栓塞预后评分',
  Qp_Qs: 'Qp:Qs',
  VR: '血管阻力',
  PS: '补钾公式',
  CCCH: '低白蛋白血症钙浓度校正',
  VRS: '癌痛主诉疼痛分级法（VRS）',
  DIA: '不良反应分级：腹泻',
  NEU: '不良反应分级：中性粒细胞减少',
  RomanIndex: '罗马指数',
  IBW: '标准体重',
  CLL_IPI: '慢性淋巴细胞白血病国际预后指数（CLL-IPI）',
  LDL: '低密度脂蛋白胆固醇计算',
  FI_C: '儿童维持液体计算',
  FI: '补液公式(成人)',
  Framingham: '心力衰竭诊断标准（Framingham）',
  IPI: '国际淋巴瘤预后指数IPI',
  PDA: '动脉导管未闭评分标准',
  CO_Fick: '估测心输出量（Fick公式）',
  CO_ultrasound: '心输出量（超声）',
  LRVS: '左室收缩/舒张末期容积指数',
  CAN: '造影剂肾病危险因素评分',
  RRF: '残余肾功能',
  Vauthey: '肝脏体积（Vauthey）计算',
  Child_Pugh: 'Child-Pugh 分级',
  MDRD: 'GFR（MDRD）',
  EKG: '心率（EKG）',
  OBRI: 'OBRI评分',
  ABCD: 'ABCD³-I评分',
  Gorlin: '心脏瓣膜面积（Gorlin）',
  FIB_4: 'FIB-4评分',
  STEMI_ECG: 'STEMI ECG指数',
  hepatitis: '肝炎判别公式',
  Glasgow: 'Glasgow酒精性肝炎评分',
  CRUSADE: 'CRUSADE评分',
  ATRIA: 'ATRIA评分',
  AGED: '年龄校准D-二聚体截断值',
  HEART: 'HEART 评分',
  HEMORR: 'HEMORR₂HAGES评分',
  RIETE: 'RIETE评分',
  ABBP: '踝肱血压指数',
  PCI: 'PCI并发症风险评估（Mayo系统）',
  TIMI: 'TIMI风险指数',
  BODE: 'BODE指数',
  serum: '血清-腹水白蛋白梯度',
  Raw: '气道阻力',
  lc: '肺顺应性',
  DO2: '氧输送（DO2）',
  STOP_BANG: 'STOP-BANG筛查工具',
  BB: '弥漫性大B细胞淋巴瘤预后分级',
  FLIPI_1: 'FLIPI-1评分',
  FLIPI_2: 'FLIPI-2评分',
  Euro: 'Euro SCORE',
  hemodynamics: '血流动力学参数',
  HP: '幽门螺旋杆菌（HP）感染诊断标准',
  Braunwald: '不稳定型心绞痛Braunwald分级',
  he: '肝性脑病分级',
  Forrester: '心力衰竭Forrester分级',
  chf: '慢性心衰分期',
  Levine6: '心脏杂音Levine6级分级',
  IPS: '霍奇金淋巴瘤（HL）国际预后评分（IPS）',
  EORTC: '膀胱癌复发风险评分（EORTC）',
  MASCC: 'MASCC评分',
  Mifflin: '基础代谢率（Mifflin公式）',
  Winters: 'PaCO₂期望值（Winters）',
  ssdh: '低钠血症时补钠量',
  bp: '行为性疼痛分级',
  FLACC: 'FLACC评分',
  Zubrod: '体力状况（Zubrod）',
  Gb: '戈沙妥珠单抗剂量',
  L_T4: '甲减L-T4治疗剂量',
  Balthazar: 'Balthazar分级',
  Alvarado: 'Alvarado评分',
  ap: '肺泡-动脉氧分压差',
  A_G: '白蛋白/球蛋白比值',
  Harris_Benedic: '基础能量消耗（Harris-Benedic公式）',
  Light: 'Light标准',
  Hestia: 'Hestia标准',
  geneva1: 'Geneva肺栓塞评分',
  Mannheim: 'Mannheim腹膜炎指数',
  bosniak: '肾囊肿bosniak分级',
  excrete: '排泄分数（钠）',
  cas: '冠状动脉狭窄分级',
  ad: '主动脉夹层分型'

}
/** 对应的描述 */
const categoryDescMap = {
  SOFA: 'SOFA评分',
  GFR_Schwartz: 'GFR（Schwartz）',
  HAS_BLED: 'HAS-BLED评分',
  GRACE: 'GRACE评分',
  SanFrancisco: 'SanFrancisco晕厥规则',
  TIMI_NSTEMI: 'TIMI评分（NSTEMI）',
  TIMI_STEMI: 'TIMI评分（STEMI）',
  MAP: '平均动脉压',
  Padua: 'Padua预测评分',
  CEF: '心脏射血分数',
  Q_Tc: 'Q-Tc',
  GFR_Salazar: 'GFR（Salazar-Corcoran）',
  GFR_Cockcroft: 'GFR（Cockcroft-Gault）',
  CFWDPH: '高钠血症患者游离水缺乏量计算',
  UCE: '尿路钙排泄',
  FOF: '1秒率',
  GFR: 'GFR（肌酐已测定）',
  PESI: '简易化PESI',
  PREP: '肺栓塞PREP评分',
  BMI: '体重指数（BMI）',
  PERC: 'PERC',
  Geneva: 'Geneva肺栓塞预后评分',
  Qp_Qs: 'Qp:Qs',
  VR: '血管阻力',
  PS: '补钾公式',
  CCCH: '低白蛋白血症钙浓度校正',
  VRS: '癌痛主诉疼痛分级法（VRS）',
  DIA: '不良反应分级：腹泻',
  NEU: '不良反应分级：中性粒细胞减少',
  RomanIndex: '罗马指数',
  IBW: '标准体重',
  CLL_IPI: '慢性淋巴细胞白血病国际预后指数（CLL-IPI）',
  LDL: '低密度脂蛋白胆固醇计算',
  FI_C: '儿童维持液体计算',
  FI: '补液公式(成人)',
  Framingham: '心力衰竭诊断标准（Framingham）',
  IPI: '国际淋巴瘤预后指数IPI',
  PDA: '动脉导管未闭评分标准',
  CO_Fick: '估测心输出量（Fick公式）',
  CO_ultrasound: '心输出量（超声）',
  LRVS: '左室收缩/舒张末期容积指数',
  CAN: '造影剂肾病危险因素评分',
  RRF: '残余肾功能',
  Vauthey: '肝脏体积（Vauthey）计算',
  Child_Pugh: 'Child-Pugh 分级',
  MDRD: 'GFR（MDRD）',
  EKG: '心率（EKG）',
  OBRI: 'OBRI评分',
  ABCD: 'ABCD³-I评分',
  Gorlin: '心脏瓣膜面积（Gorlin）',
  FIB_4: 'FIB-4评分',
  STEMI_ECG: 'STEMI ECG指数',
  hepatitis: '肝炎判别公式',
  Glasgow: 'Glasgow酒精性肝炎评分',
  CRUSADE: 'CRUSADE评分',
  ATRIA: 'ATRIA评分',
  AGED: '年龄校准D-二聚体截断值',
  HEART: 'HEART 评分',
  HEMORR: 'HEMORR₂HAGES评分',
  RIETE: 'RIETE评分',
  ABBP: '踝肱血压指数',
  PCI: 'PCI并发症风险评估（Mayo系统）',
  TIMI: 'TIMI风险指数',
  BODE: 'BODE指数',
  serum: '血清-腹水白蛋白梯度',
  Raw: '气道阻力',
  lc: '肺顺应性',
  DO2: '氧输送（DO2）',
  STOP_BANG: 'STOP-BANG筛查工具',
  BB: '弥漫性大B细胞淋巴瘤预后分级',
  FLIPI_1: 'FLIPI-1评分',
  FLIPI_2: 'FLIPI-2评分',
  Euro: 'Euro SCORE',
  hemodynamics: '血流动力学参数',
  HP: '幽门螺旋杆菌（HP）感染诊断标准',
  Braunwald: '不稳定型心绞痛Braunwald分级',
  he: '肝性脑病分级',
  Forrester: '心力衰竭Forrester分级',
  chf: '慢性心衰分期',
  Levine6: '心脏杂音Levine6级分级',
  IPS: '霍奇金淋巴瘤（HL）国际预后评分（IPS）',
  EORTC: '膀胱癌复发风险评分（EORTC）',
  MASCC: 'MASCC评分',
  Mifflin: '基础代谢率（Mifflin公式）',
  Winters: 'PaO₂期望值（Winters）',
  ssdh: '低钠血症时补钠量',
  bp: '行为性疼痛分级',
  FLACC: 'FLACC评分',
  Zubrod: '体力状况（Zubrod）',
  Gb: '戈沙妥珠单抗剂量',
  L_T4: '甲减L-T4治疗剂量',
  Balthazar: 'Balthazar分级',
  Alvarado: 'Alvarado评分',
  ap: 'A-a氧分压差',
  A_G: '白蛋白/球蛋白比值',
  Harris_Benedic: '基础能量消耗（Harris-Benedic公式）',
  Light: 'Light标准',
  Hestia: 'Hestia标准',
  geneva1: 'Geneva肺栓塞评分',
  Mannheim: 'Mannheim腹膜炎指数',
  bosniak: '肾囊肿bosniak分级',
  excrete: '排泄分数（钠）',
  cas: '冠状动脉狭窄分级',
  ad: '主动脉夹层分型'

}
/** 没有公式描述的页面 */
const categoryNotInfoMap = {}
export default {
  categoryMap,
  categoryDescMap,
  categoryNotInfoMap
}



// WEBPACK FOOTER //
// ./src/utils/category/NewFormulas.js